import { useState } from 'react'

import { Box, Button, SearchField } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { DateNavigator } from 'modules/core/components/DateNavigator'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ScheduleRecordValuesType } from 'modules/project_management/components/Schedule/Body/ScheduleItem/types'
import { ExportSidepanel } from 'modules/universal_exports/components/ExportSidepanel'

import ProjectFilter from './ProjectFilter'
import VisibilityPopover from './VisibilityPopover'

interface IScheduleActionsProps {
  range: [Date, Date]
  setRange: (range: [Date, Date]) => void
  openSidepanel: (data?: ScheduleRecordValuesType | null) => void
  onChangeFilter: (filterValue: Record<string, number[]>) => void
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
  search: string
  isMyProjectsView?: boolean
}

const ScheduleActions = ({
  range,
  setRange,
  openSidepanel,
  onChangeFilter,
  onSearch,
  search,
  isMyProjectsView = false,
}: IScheduleActionsProps) => {
  const [showExportSidepanel, setShowExportSidepanel] = useState(false)
  const onClickToday = () => {
    setRange([moment().startOf('month').toDate(), moment().endOf('month').toDate()])
  }

  const handleOnClickAssignHoursButton = () => {
    track(trackingEvents.projectManagement.schedule.clickAssignHoursButton, {})
    openSidepanel()
  }

  return (
    <Box flexDirection="row" justifyContent="spaceBetween" paddingY="s16">
      <Box flexDirection="row">
        {!isMyProjectsView && <ProjectFilter onChangeFilter={onChangeFilter} />}
      </Box>
      <Box flexDirection="row" alignItems="center" gap="s8">
        <Button type="secondary" onClick={onClickToday}>
          {i18n.t('common.today')}
        </Button>
        <DateNavigator
          regularPeriods={['month']}
          startDate={range[0] ?? new Date()}
          endDate={range[1] ?? new Date()}
          onDateRangeChange={(...newRange) => setRange(newRange)}
        />
        <VisibilityPopover />
      </Box>

      <Box flexDirection="row" justifyContent="flexStart" paddingX="s24">
        {!isMyProjectsView && (
          <Box flexDirection="row" gap="s8">
            <SearchField
              collapsable
              search={search}
              onSearch={onSearch}
              placeholder={i18n.t('common.search')}
            />
            <Button type="secondary" onClick={() => setShowExportSidepanel(true)}>
              {i18n.t('project_management.schedule.buttons.export')}
            </Button>

            <Button iconName="add" type="primary" onClick={handleOnClickAssignHoursButton}>
              {i18n.t('project_management.schedule.buttons.assign_hours')}
            </Button>
          </Box>
        )}
      </Box>
      {!isMyProjectsView && showExportSidepanel && (
        <ExportSidepanel
          resource="project_management.exportable_schedule"
          onClose={() => setShowExportSidepanel(false)}
        />
      )}
    </Box>
  )
}

export default ScheduleActions
